import { 
    auth, 
    googleProvider 
} from '../config/firebase';
import { 
    signInWithPopup, 
    signOut,
    createUserWithEmailAndPassword,
    updateProfile,
    signInWithEmailAndPassword
} from 'firebase/auth';

const authService = {
    async signupWithGoogle() {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            return { user: result.user };
        } catch (error) {
            console.error('Google signup error:', error);
            throw error;
        }
    },

    async signupWithEmail(email, password, firstName, lastName) {
        try {
            const result = await createUserWithEmailAndPassword(auth, email, password);
            await updateProfile(result.user, {
                displayName: `${firstName} ${lastName}`
            });
            return result.user;
        } catch (error) {
            console.error('Email signup error:', error);
            throw error;
        }
    },

    async logout() {
        try {
            await signOut(auth);
        } catch (error) {
            console.error('Logout error:', error);
            throw error;
        }
    },

    async loginWithEmail(email, password) {
        try {
            const result = await signInWithEmailAndPassword(auth, email, password);
            return { user: result.user };
        } catch (error) {
            console.error('Email login error:', error);
            throw error;
        }
    }
};

export default authService; 